import styled from 'styled-components';
import { flexbox, justifyContent, alignItems } from '../../styles/helpers/flexbox';
import ThemeHelper from '../../themes/theme-helper';

const ButtonWrapper = styled.div((props) => {
    const { layout, colours, palette } = ThemeHelper.getTheme(props);

    let borderColour = 'transparent';
    let bgColor = 'transparent';
    let textColor = palette.primary.main;
    let borderRadius = layout.borderRadius;
    let fontWeight = 300;
    let componentDisplay = flexbox();
    let isComponentdisabled = '';
    let circleButtonHeight = '';
    let iconStyles = '';

    if (props.primary) {
        borderColour = palette.primary.dark;
        bgColor = palette.primary.main;
        textColor = palette.primary.text;
        borderRadius = '35px';
        fontWeight = 500;
    } else if (props.basic) {
        borderColour = colours.grey[200];
        bgColor = '#fff';
    } else if (props.circle) {
        borderColour = palette.primary.dark;
        borderRadius = '80px';
        circleButtonHeight = 'height: 80px;';
    }

    if (props.inline) {
        componentDisplay = 'display: inline-block;';
    }

    if (props.success) {
        bgColor = palette.success.main;
        borderColour = palette.success.main;
        textColor = '#fff';
    }

    if (props.warning) {
        bgColor = palette.error.main;
        borderColour = palette.error.main;
        textColor = '#fff';
    }

    if (props.warning || props.success) {
        iconStyles = `
        svg {
            width: 25px;
            height: 25px;

            path { fill: #fff !important; }
        }`;
    }

    if (props.disabled) {
        isComponentdisabled = `
        opacity: 0.4;
        pointer-events: none;
        cursor: not-allowed;
        `;
    }

    return `
    ${justifyContent('center')}
    ${alignItems('center')}
    background-color: ${bgColor};
    border: 1px solid ${borderColour};
    border-radius: ${borderRadius};
    min-width: 80px;
    outline: none;
    cursor: pointer;
    color: ${textColor};
    font-weight: ${fontWeight};

    ${componentDisplay}
    ${isComponentdisabled}
    ${circleButtonHeight}
    & > div {
        ${flexbox()}
        ${justifyContent('center')}
        ${alignItems('center')}

        padding: ${layout.spacing}px;
    }
    ${iconStyles}
    `;
});

export default ButtonWrapper;



// WEBPACK FOOTER //
// ./app/components/button/styled.js